import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "selected-summary"
};
const _hoisted_2 = {
  class: "product-select-toolbar"
};
const _hoisted_3 = {
  key: 0,
  class: "option-check"
};
import { computed } from 'vue';
import { DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES, ENTERPRISE_INVOICE_PRODUCT_NAMES, normalizeProductNames } from '../productNames';
export default {
  __name: 'InvoiceProductNameSelect',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: '品名'
    },
    placeholder: {
      type: String,
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const normalizedValue = computed(() => normalizeProductNames(props.modelValue));
    const selectedSummary = computed(() => `已选 ${normalizedValue.value.length} 项`);
    const placeholderText = computed(() => props.placeholder || `请选择${props.label}`);
    function updateValue(value) {
      emit('update:modelValue', normalizeProductNames(value));
    }
    function isSelected(name) {
      return normalizedValue.value.includes(name);
    }
    function checkIconVisible(name) {
      return isSelected(name);
    }
    function selectAll() {
      emit('update:modelValue', [...ENTERPRISE_INVOICE_PRODUCT_NAMES]);
    }
    function clearToDefault() {
      emit('update:modelValue', [...DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES]);
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['invoice-product-name-select', __props.compact ? 'is-compact' : ''])
      }, [_createVNode(_component_el_select, {
        "model-value": normalizedValue.value,
        multiple: "",
        "collapse-tags": "",
        "collapse-tags-tooltip": "",
        "max-collapse-tags": __props.compact ? 1 : 2,
        placeholder: placeholderText.value,
        disabled: __props.disabled,
        class: _normalizeClass(['w-full', __props.compact ? 'invoice-product-name-select-control is-compact' : 'invoice-product-name-select-control']),
        "onUpdate:modelValue": updateValue
      }, {
        prefix: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString(selectedSummary.value), 1)]),
        header: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
          type: "button",
          class: "select-all",
          onClick: _withModifiers(selectAll, ["stop"])
        }, "全选"), _createElementVNode("button", {
          type: "button",
          class: "select-all",
          onClick: _withModifiers(clearToDefault, ["stop"])
        }, "默认")])]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ENTERPRISE_INVOICE_PRODUCT_NAMES), name => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: name,
            label: name,
            value: name
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(['option-row', isSelected(name) ? 'is-selected' : ''])
            }, [_createElementVNode("span", null, _toDisplayString(name), 1), checkIconVisible(name) ? (_openBlock(), _createElementBlock("span", _hoisted_3, "已选")) : _createCommentVNode("", true)], 2)]),
            _: 2
          }, 1032, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["model-value", "max-collapse-tags", "placeholder", "disabled", "class"])], 2);
    };
  }
};